import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { buildItemOperationalTimeline } from '@/services/inventoryMovements';
import type { TimelineEntry } from '@/services/inventoryMovements/types';
import { modulePaths } from '@/routes/paths';

const SOURCE_LABELS: Record<TimelineEntry['source'], string> = {
  movement: 'Movimiento',
  reservation: 'Reserva',
  maintenance: 'Mantenimiento',
  logistics: 'Logística',
};

type ItemOperationalTimelineProps = {
  itemId: string;
};

function entityLink(entry: TimelineEntry): string | null {
  switch (entry.source) {
    case 'reservation':
      return `${modulePaths.reservations}/${entry.entityId}`;
    case 'maintenance':
      return `${modulePaths.maintenance}/${entry.entityId}`;
    case 'logistics':
      return `${modulePaths.logistics}/${entry.entityId}`;
    default:
      return null;
  }
}

export function ItemOperationalTimeline({ itemId }: ItemOperationalTimelineProps) {
  const [entries, setEntries] = useState<TimelineEntry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    void buildItemOperationalTimeline(itemId)
      .then(setEntries)
      .finally(() => setLoading(false));
  }, [itemId]);

  if (loading) return <p className="auth-muted">Cargando timeline…</p>;
  if (entries.length === 0) {
    return <p className="auth-muted">Sin eventos operativos registrados.</p>;
  }

  return (
    <ul className="inventory-timeline">
      {entries.map((e) => {
        const href = entityLink(e);
        return (
          <li key={e.id} className={`inventory-timeline__item inventory-timeline--${e.source}`}>
            <span className="inventory-timeline__date">
              {new Date(e.occurredAt).toLocaleString('es-AR')}
            </span>
            <span className="inventory-timeline__badge">{SOURCE_LABELS[e.source]}</span>
            <strong>
              {href ? <Link to={href}>{e.title}</Link> : e.title}
            </strong>
            <span className="auth-muted">
              {e.typeLabel} · {e.subtitle}
            </span>
          </li>
        );
      })}
    </ul>
  );
}
